import { Box, Grid } from "@mui/material";
import { IMaterialReports, MaterialReportsSchema } from "../api/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { CloudDownloadOutlined } from "@ant-design/icons";
import api from "utils/api";
import { useState } from "react";
import AnimateButton from "components/@extended/AnimateButton";
import LoadingButton from "@mui/lab/LoadingButton";
import MainCard from "components/MainCard";

const MaterialReports = () => {
  const apiURL = "api/Reports/materialReports";
  const fileName = "MaterialReports";
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<IMaterialReports>({
    resolver: zodResolver(MaterialReportsSchema),
  });

  const onSubmit = handleSubmit((data) => {
    setLoading(true);

    if (isSubmitting) return;
    api.downloadExcel(apiURL, fileName, data, setLoading);
  });

  return (
    <MainCard
      darkTitle
      title="Material and Accession Export"
      darktitleVariant={"h4"}
    >
      <Box component={"form"} onSubmit={onSubmit}>
        <Grid container gap={2} direction={"row"}>
          <Grid item>
            <AnimateButton>
              <LoadingButton
                disabled={isSubmitting}
                type="submit"
                variant="contained"
                loading={loading}
                loadingPosition="start"
                startIcon={<CloudDownloadOutlined />}
              >
                Download All Records
              </LoadingButton>
            </AnimateButton>
          </Grid>
        </Grid>
      </Box>
    </MainCard>
  );
};

export default MaterialReports;
